import PrivateRoute from "./components/PrivateRoute/privateRoutes";
import React, { useEffect, useState } from "react";
import { AuthProvider } from "./context/AuthContext";
import { Route, Switch } from "react-router-dom";
import axios from "axios";

import Inicio from "./pages/Inicio/Inicio";
import Relatorio from "./pages/Notas/Relatorio";
import Calendario from "./pages/Horarios/Calendario";
import Conteudos from "./pages/Conteudos/Conteudos/Conteudos";
import Drive from "./pages/Conteudos/Drive/Drive";

export default function Layout() {
    const [axiosReady, setAxiosReady] = useState(false);

    useEffect(() => {
        if (localStorage.getItem("accessToken"))
            axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem("accessToken")}`;

        setAxiosReady(true);
    }, []);

    return (
        axiosReady && (
            <AuthProvider>
                <Switch>
                    <Route
                        path="/:entidade/area-aluno/relatorio/:id"
                        render={() => (
                            <PrivateRoute>
                                <Relatorio />
                            </PrivateRoute>
                        )}
                    />
                    <Route
                        path="/:entidade/area-aluno/calendario/:id"
                        render={() => (
                            <PrivateRoute>
                                <Calendario />
                            </PrivateRoute>
                        )}
                    />
                    <Route
                        path="/:entidade/area-aluno/conteudos/:id"
                        render={() => (
                            <PrivateRoute>
                                <Conteudos />
                            </PrivateRoute>
                        )}
                    />
                    <Route
                        path="/:entidade/area-aluno/drive/:id"
                        render={() => (
                            <PrivateRoute>
                                <Drive />
                            </PrivateRoute>
                        )}
                    />
                    <Route
                        path="/:entidade/area-aluno"
                        render={() => (
                            <PrivateRoute>
                                <Inicio />
                            </PrivateRoute>
                        )}
                    />
                </Switch>
            </AuthProvider>
        )
    );
}
